/**
 * @fileoverview Animals theme - match animal emojis.
 */

import { ThemeOptions } from '../../../../services/ThemeService.js';
import { EmojiMatchingTheme } from '../../../abstract/EmojiMatchingTheme.js';
import { allLabels } from '../../../Labels.js';

export class InsectsTheme extends EmojiMatchingTheme {
    constructor(options: ThemeOptions = {}) {
        super(
            'insects',
            'Insects',
            allLabels.insects,
            { numPairs: 6, ...options }
        );
    }
}
